import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Button from "react-bootstrap/Button";
import ModalCondicion from "./modal";
import { Col } from "react-bootstrap";
import { PageTitle } from "../../../../_metronic/layout/core";

const API_URL = process.env.REACT_APP_API_URL
export default class Subcontextos extends Component {

    constructor() {
        super();
        this.state = { data: [] };
        this.refreshTable = this.refreshTable.bind(this);
    }

    async componentDidMount() {
        this.refreshTable();
    }

    async refreshTable() {
        try {
            const response = await fetch(`${API_URL}/subcontexto/getAll`);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const data = await response.json();
            this.setState({ data: data });
        } catch (err) {
            console.log(err.message);
        };
    }

    render() {
        //var moment = require('moment');
        return (
            <>
                <PageTitle breadcrumbs={[]}>Condiciones Diferenciadoras</PageTitle>
                <Container fluid>
                    <Row>
                        <Col>
                            <Form>
                                <Form.Group controlId="formSearch">
                                    <FloatingLabel
                                        controlId="buscaPersona"
                                        label="Buscar Persona"
                                        className="mb-3"
                                    >
                                        <Form.Control type="text" placeholder="Buscar Persona" />
                                    </FloatingLabel>
                                </Form.Group>
                            </Form>
                        </Col>
                        <Col>
                            <ModalCondicion action="insert" refreshTable={this.refreshTable}>Agregar Subcontexto</ModalCondicion>
                        </Col>
                    </Row>
                    <Row>
                        <Table className="table table-row-dashed table-row-gray-300 gy-7" responsive='lg'>
                            <thead>
                                <tr className="fw-bolder fs-6 text-gray-800">
                                    <th>Nombre</th>
                                    <th>Descripción</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.data.map(post =>
                                        <tr key={post._id}>
                                            <td>{post.nombre}</td>
                                            <td>{post.descripcion}</td>
                                            <td>
                                                <ModalCondicion item={post} titulo="Editar" action="update" refreshTable={this.refreshTable}>Editar</ModalCondicion>{' '}
                                                <Button>Eliminar</Button>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>
                    </Row>
                </Container>
            </>
        );
    }

}